<div class="labeled-dropdown datatype">
    <label>Query Type</label>

    @if (enabled) {
        <div class="arrow-selector">
            <app-dropdown
                id="named-query-type-select"
                [options]="queryTypeList"
                [readonly]="isReadOnly"
                [(selected)]="queryType"
                (selectedChange)="onQueryTypeChanged()"
            >
            </app-dropdown>
        </div>
    } @else {
        <div>
            <span class="disabled-label">{{ queryType.text !== 'ALL' ? queryType.text : 'TBD' }}</span>
        </div>
    }
</div>

<div class="labeled-dropdown">
    <label>Name</label>

    @if (enabled) {
        <div>
            <app-typeahead
                [dataSource]="filteredNamedQueries"
                [configuration]="{ placeholder: 'Name', displayProperty: 'name' }"
                [preSelectedItem]="preSelectedItem"
                [readonly]="isReadOnly"
                (itemSelected)="onNamedQuerySelected($event)"
            >
            </app-typeahead>
        </div>
    } @else {
        <div>
            <span class="disabled-label">{{ namedQuery?.name || 'TBD' }}</span>
        </div>
    }

    <div class="manage-button-container" [ngClass]="{'readonly': isReadOnly}">
        <a
            class="manage-button"
            target="_blank"
            [href]="routerLink"
        >
            {{ namedQuery ? 'edit query' : 'new query' }}
        </a>
    </div>
</div>
